import { Outlet } from "@tanstack/react-router"
import { useGsapLoading } from "@/shared/hooks/use-gsap-loading"

export function AuthLayout() {
  const containerRef = useGsapLoading({ 
    animationType: 'fadeIn', 
    duration: 1.0, 
    stagger: 0.1 
  })

  return (
    <div ref={containerRef} className="min-h-screen bg-gray-50" data-gsap-animate>
      <Outlet />
    </div>
  )
}
